
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModules } from '../shared/material-modules';
import { provideNativeDateAdapter } from '@angular/material/core';

import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';


@NgModule({
  imports: [CommonModule, MaterialModules],
  declarations: [],
  exports: [CommonModule, MaterialModules, ],
  providers: [provideNativeDateAdapter()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
